'use strict';

Object.defineProperty(exports, "__esModule", {
	value: true
});

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/**
 * Adapter to convert a swagger-ui request into an object that is suitable for
 * generating code examples.
 */
var ExampleRequest = function () {
	_createClass(ExampleRequest, null, [{
		key: 'from',

		/**
   * Adapts a swagger-client request
   * @param {object} request - A swagger-ui request object (see
   *	swagger-ui/src/core/components/live-response.jsx)
   */
		value: function from(request) {
			return new ExampleRequest(request);
		}

		/**
   * Constructor
   * @param {object} request - A swagger-ui request object (see
   *	swagger-ui/src/core/components/live-response.jsx)
   */

	}]);

	function ExampleRequest(request) {
		_classCallCheck(this, ExampleRequest);

		this.request = request;
	}

	/**
  * Get the request method.
  * @return {string} The HTTP method
  */


	_createClass(ExampleRequest, [{
		key: 'method',
		get: function get() {
			return this.request.get('method');
		}

		/**
   * Get the request URL.
   * @return {string} The HTTP URL
   */

	}, {
		key: 'url',
		get: function get() {
			return this.request.get('url');
		}

		/**
   * Get the request headers as an object of key/values.
   * @return {object} The HTTP headers
   */

	}, {
		key: 'headers',
		get: function get() {
			var headers = {};
			this.request.get('headers').entrySeq().forEach(function (_ref) {
				var _ref2 = _slicedToArray(_ref, 2),
				    name = _ref2[0],
				    value = _ref2[1];

				headers[name] = value;
			});
			return headers;
		}

		/**
   * Get the request body.  Returns an object of key/values (e.g. a form), a
   * JSON object (if the content-type is JSON), a string, or null.
   * @return {object} The HTTP body
   */

	}, {
		key: 'body',
		get: function get() {
			var body = this.request.get('body');
			if ((typeof body === 'undefined' ? 'undefined' : _typeof(body)) === 'object' && !(body instanceof File)) {
				// The swagger-ui request object might pass the request body as an object.
				// It is not a standard Object and it will not behave as expected.  The
				// object represents a form of name/value pairs.  Convert to standard
				// Object.
				var converted = {};
				var _iteratorNormalCompletion = true;
				var _didIteratorError = false;
				var _iteratorError = undefined;

				try {
					for (var _iterator = body.entrySeq()[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
						var _ref3 = _step.value;

						var _ref4 = _slicedToArray(_ref3, 2);

						var name = _ref4[0];
						var value = _ref4[1];

						converted[name] = value;
					}
				} catch (err) {
					_didIteratorError = true;
					_iteratorError = err;
				} finally {
					try {
						if (!_iteratorNormalCompletion && _iterator.return) {
							_iterator.return();
						}
					} finally {
						if (_didIteratorError) {
							throw _iteratorError;
						}
					}
				}

				body = converted;
			} else if (this.contentType.includes('application/json')) {
				// The swagger-ui request object might pass the request body as a string.
				// If it is, parse it.
				try {
					body = JSON.parse(body);
				} catch (err) {
					// gobble
				}
			}
			return body;
		}

		/**
   * Get the content-type.
   * @private
   * @return {string} The content-type value from the header, or empty string.
   */

	}, {
		key: 'contentType',
		get: function get() {
			var entries = this.request.get('headers').entrySeq();
			var _iteratorNormalCompletion2 = true;
			var _didIteratorError2 = false;
			var _iteratorError2 = undefined;

			try {
				for (var _iterator2 = entries[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
					var _ref5 = _step2.value;

					var _ref6 = _slicedToArray(_ref5, 2);

					var name = _ref6[0];
					var value = _ref6[1];

					if (name.toLowerCase() === 'content-type') {
						return value;
					}
				}
			} catch (err) {
				_didIteratorError2 = true;
				_iteratorError2 = err;
			} finally {
				try {
					if (!_iteratorNormalCompletion2 && _iterator2.return) {
						_iterator2.return();
					}
				} finally {
					if (_didIteratorError2) {
						throw _iteratorError2;
					}
				}
			}

			return '';
		}
	}]);

	return ExampleRequest;
}();

var _default = ExampleRequest;
exports.default = _default;
;

var _temp = function () {
	if (typeof __REACT_HOT_LOADER__ === 'undefined') {
		return;
	}

	__REACT_HOT_LOADER__.register(ExampleRequest, 'ExampleRequest', 'src/components/OpenAPI/ExampleRequest.js');

	__REACT_HOT_LOADER__.register(_default, 'default', 'src/components/OpenAPI/ExampleRequest.js');
}();

;